import type { WalletBillingAddress } from 'commons/types/paymentTypes'

const record = (value: unknown): Record<string, unknown> | null =>
	value !== null && typeof value === 'object' && !Array.isArray(value)
		? (value as Record<string, unknown>)
		: null

const text = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

export const normalizeWalletBillingAddress = (value: unknown): WalletBillingAddress | null => {
	const result = record(value)
	if (!result) return null

	const appleContact = record(record(result.payment)?.billingContact)
	if (appleContact) {
		const lines = Array.isArray(appleContact.addressLines)
			? appleContact.addressLines.map(text).filter(Boolean)
			: []
		return {
			firstname: text(appleContact.givenName),
			lastname: text(appleContact.familyName),
			address1: lines[0] || '',
			address2: lines[1] || '',
			address3: lines.slice(2).join(' '),
			city: text(appleContact.locality),
			country: text(appleContact.countryCode).toUpperCase(),
			zipcode: text(appleContact.postalCode)
		}
	}

	const googleAddress = record(record(record(result.paymentMethodData)?.info)?.billingAddress)
	if (!googleAddress) return null
	const [firstname = '', ...lastnames] = text(googleAddress.name).split(/\s+/)
	return {
		firstname,
		lastname: lastnames.join(' '),
		address1: text(googleAddress.address1),
		address2: text(googleAddress.address2),
		address3: text(googleAddress.address3),
		city: text(googleAddress.locality),
		country: text(googleAddress.countryCode).toUpperCase(),
		zipcode: text(googleAddress.postalCode)
	}
}
